import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const regionDataClassName = DataClassName.REGION
const regionEndpoint = PisaDataClassEndpoint.REGION

export function pisaRegionDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(regionDataClassName, {
    title: regionDataClassName,
    restApi: createPisaRestApiConfig(regionEndpoint),
    attributes,
  })
}
